/*
* picasso-plugin-q v2.8.2
* Copyright (c) 2025 QlikTech International AB
* Released under the MIT license.
*/


(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.picassoQ = factory());
})(this, (function () { 'use strict';

  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }

  var hasOwn = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var defineProperty = Object.defineProperty;
  var gOPD = Object.getOwnPropertyDescriptor;

  var isArray = function isArray(arr) {
  	if (typeof Array.isArray === 'function') {
  		return Array.isArray(arr);
  	}

  	return toStr.call(arr) === '[object Array]';
  };

  var isPlainObject = function isPlainObject(obj) {
  	if (!obj || toStr.call(obj) !== '[object Object]') {
  		return false;
  	}

  	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
  	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
  	// Not own constructor property must be Object
  	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
  		return false;
  	}

  	// Own properties are enumerated firstly, so to speed up,
  	// if last one is own, then all properties are own.
  	var key;
  	for (key in obj) { /**/ }

  	return typeof key === 'undefined' || hasOwn.call(obj, key);
  };

  // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
  var setProperty = function setProperty(target, options) {
  	if (defineProperty && options.name === '__proto__') {
  		defineProperty(target, options.name, {
  			enumerable: true,
  			configurable: true,
  			value: options.newValue,
  			writable: true
  		});
  	} else {
  		target[options.name] = options.newValue;
  	}
  };

  // Return undefined instead of __proto__ if '__proto__' is not an own property
  var getProperty = function getProperty(obj, name) {
  	if (name === '__proto__') {
  		if (!hasOwn.call(obj, name)) {
  			return void 0;
  		} else if (gOPD) {
  			// In early versions of node, obj['__proto__'] is buggy when obj has
  			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
  			return gOPD(obj, name).value;
  		}
  	}

  	return obj[name];
  };

  var extend = function extend() {
  	var options, name, src, copy, copyIsArray, clone;
  	var target = arguments[0];
  	var i = 1;
  	var length = arguments.length;
  	var deep = false;

  	// Handle a deep copy situation
  	if (typeof target === 'boolean') {
  		deep = target;
  		target = arguments[1] || {};
  		// skip the boolean and the target
  		i = 2;
  	}
  	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
  		target = {};
  	}

  	for (; i < length; ++i) {
  		options = arguments[i];
  		// Only deal with non-null/undefined values
  		if (options != null) {
  			// Extend the base object
  			for (name in options) {
  				src = getProperty(target, name);
  				copy = getProperty(options, name);

  				// Prevent never-ending loop
  				if (target !== copy) {
  					// Recurse if we're merging plain objects or arrays
  					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
  						if (copyIsArray) {
  							copyIsArray = false;
  							clone = src && isArray(src) ? src : [];
  						} else {
  							clone = src && isPlainObject(src) ? src : {};
  						}

  						// Never move original objects, clone them
  						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

  					// Don't bring in undefined values
  					} else if (typeof copy !== 'undefined') {
  						setProperty(target, { name: name, newValue: copy });
  					}
  				}
  			}
  		}
  	}

  	// Return the modified object
  	return target;
  };

  /* eslint no-nested-ternary: 0 */
  function getFieldAccessor$1(field, page, deps, columnOrder) {
    if (!field) {
      return -1;
    }
    const cache = deps.cache;
    const origin = field.origin ? field.origin() : null;
    if (origin) {
      field = origin;
    }
    let fieldIdx = cache.fields.indexOf(field);
    let attrIdx = -1;
    let attrDimIdx = -1;
    if (fieldIdx === -1) {
      for (let i = 0; i < cache.wrappedFields.length; i++) {
        attrDimIdx = cache.wrappedFields[i].attrDims.map(v => v.instance).indexOf(field);
        attrIdx = cache.wrappedFields[i].attrExps.map(v => v.instance).indexOf(field);
        if (attrDimIdx !== -1 || attrIdx !== -1) {
          fieldIdx = i;
          break;
        }
      }
    }
    if (Array.isArray(columnOrder) && columnOrder.some((el, i) => el !== i)) {
      const correctIndex = columnOrder.indexOf(fieldIdx);
      if (correctIndex !== -1) {
        fieldIdx = correctIndex;
      }
    }
    fieldIdx -= page.qArea.qLeft;
    if (fieldIdx < 0 || fieldIdx >= page.qArea.qWidth) {
      // throw new Error('Field out of range');
      return -1;
    }
    if (attrDimIdx >= 0) {
      return row => row[fieldIdx].qAttrDims.qValues[attrDimIdx];
    }
    if (attrIdx >= 0) {
      return row => row[fieldIdx].qAttrExps.qValues[attrIdx];
    }
    return row => row[fieldIdx];
  }

  // TODO - handle 'other' value
  // const specialTextValues = {
  //   '-3': (meta) => {
  //     if ('othersLabel' in meta) {
  //       return meta.othersLabel;
  //     }
  //     return '';
  //   }
  // };

  function datumExtract$1(propCfg, cell, _ref) {
    let {
      key
    } = _ref;
    const datum = {
      value: typeof propCfg.value === 'function' ? propCfg.value(cell) : typeof propCfg.value !== 'undefined' ? propCfg.value : cell // eslint-disable-line no-nested-ternary
    };
    datum.label = typeof propCfg.label === 'function' ? propCfg.label(cell) : typeof propCfg.label !== 'undefined' ? String(propCfg.label) : String(datum.value); // eslint-disable-line no-nested-ternary

    if (propCfg.field) {
      datum.source = {
        key,
        field: propCfg.field.key()
      };
    }
    return datum;
  }
  function cellToValue(_ref2) {
    let {
      cache,
      f,
      mainCell,
      p,
      prop,
      page,
      rowIdx,
      row,
      sourceKey,
      target,
      targetProp,
      columnOrder
    } = _ref2;
    let propCell = mainCell;
    if (p.field && p.field !== f) {
      const propCellFn = getFieldAccessor$1(p.field, page, {
        cache
      }, columnOrder);
      if (propCellFn === -1) {
        return;
      }
      propCell = extend({
        qRow: rowIdx
      }, propCellFn(row));
    }
    target[targetProp] = datumExtract$1(p, propCell, {
      key: sourceKey
    });
  }
  function extract$1(config, dataset, cache, util) {
    const cfgs = Array.isArray(config) ? config : [config];
    let dataItems = [];
    for (let i = 0; i < cfgs.length; i++) {
      if (typeof cfgs[i].field !== 'undefined') {
        const cube = dataset.raw();
        const sourceKey = dataset.key();
        const f = typeof cfgs[i].field === 'object' ? cfgs[i].field : dataset.field(cfgs[i].field);
        const {
          props,
          main
        } = util.normalizeConfig(cfgs[i], dataset);
        const propsArr = Object.keys(props);
        const track = !!cfgs[i].trackBy;
        const trackType = typeof cfgs[i].trackBy;
        const tracker = {};
        const trackedItems = [];
        const items = [];
        for (let j = 0; j < cube.qDataPages.length; j++) {
          const fn = getFieldAccessor$1(f, cube.qDataPages[j], {
            cache
          }, cube.qColumnOrder);
          if (fn === -1) {
            continue;
          }
          for (let k = 0; k < cube.qDataPages[j].qMatrix.length; k++) {
            const rowIdx = cube.qDataPages[j].qArea.qTop + k;
            const mainCell = extend({
              qRow: rowIdx
            }, fn(cube.qDataPages[j].qMatrix[k]));
            const ret = datumExtract$1(main, mainCell, {
              key: sourceKey
            });
            const exclude = main.filter && !main.filter(mainCell);
            if (exclude) {
              continue;
            }
            for (let l = 0; l < propsArr.length; l++) {
              const p = props[propsArr[l]];
              let arr = p.fields || [p];
              if (p.fields) {
                ret[propsArr[l]] = [];
              }

              // loop through all props that need to be mapped and
              // assign 'value' and 'source' to each property
              for (let m = 0; m < arr.length; m++) {
                cellToValue({
                  cache,
                  f,
                  mainCell,
                  p: arr[m],
                  prop: propsArr[l],
                  props,
                  page: cube.qDataPages[j],
                  rowIdx,
                  row: cube.qDataPages[j].qMatrix[k],
                  sourceKey,
                  target: p.fields ? ret[propsArr[l]] : ret,
                  targetProp: p.fields ? m : propsArr[l],
                  columnOrder: cube.qColumnOrder
                });
              }
              if (p.fields) {
                const fieldValues = ret[propsArr[l]].map(v => v.value);
                const fieldLabels = ret[propsArr[l]].map(v => v.label);
                ret[propsArr[l]] = {
                  value: typeof p.value === 'function' ? p.value(fieldValues) : typeof p.value !== 'undefined' ? p.value : fieldValues,
                  label: typeof p.label === 'function' ? p.label(fieldLabels) : typeof p.label !== 'undefined' ? String(p.label) : String(ret[propsArr[l]].value)
                };
              }
            }

            // collect items based on the trackBy value
            // items with the same trackBy value are placed in an array and reduced later
            if (track) {
              util.track({
                cfg: cfgs[i],
                itemData: mainCell,
                obj: ret,
                target: trackedItems,
                tracker,
                trackType
              });
            }
            items.push(ret);
          }
        }

        // reduce if items have been grouped
        const tmp = track ? util.collect(trackedItems, {
          main,
          propsArr,
          props
        }) : items;
        dataItems = [...dataItems, ...tmp];
      }
    }
    return dataItems;
  }

  function count(node) {
    var sum = 0,
        children = node.children,
        i = children && children.length;
    if (!i) sum = 1;
    else while (--i >= 0) sum += children[i].value;
    node.value = sum;
  }

  function node_count() {
    return this.eachAfter(count);
  }

  function node_each(callback, that) {
    let index = -1;
    for (const node of this) {
      callback.call(that, node, ++index, this);
    }
    return this;
  }

  function node_eachBefore(callback, that) {
    var node = this, nodes = [node], children, i, index = -1;
    while (node = nodes.pop()) {
      callback.call(that, node, ++index, this);
      if (children = node.children) {
        for (i = children.length - 1; i >= 0; --i) {
          nodes.push(children[i]);
        }
      }
    }
    return this;
  }

  function node_eachAfter(callback, that) {
    var node = this, nodes = [node], next = [], children, i, n, index = -1;
    while (node = nodes.pop()) {
      next.push(node);
      if (children = node.children) {
        for (i = 0, n = children.length; i < n; ++i) {
          nodes.push(children[i]);
        }
      }
    }
    while (node = next.pop()) {
      callback.call(that, node, ++index, this);
    }
    return this;
  }

  function node_find(callback, that) {
    let index = -1;
    for (const node of this) {
      if (callback.call(that, node, ++index, this)) {
        return node;
      }
    }
  }

  function node_sum(value) {
    return this.eachAfter(function(node) {
      var sum = +value(node.data) || 0,
          children = node.children,
          i = children && children.length;
      while (--i >= 0) sum += children[i].value;
      node.value = sum;
    });
  }

  function node_sort(compare) {
    return this.eachBefore(function(node) {
      if (node.children) {
        node.children.sort(compare);
      }
    });
  }

  function node_path(end) {
    var start = this,
        ancestor = leastCommonAncestor(start, end),
        nodes = [start];
    while (start !== ancestor) {
      start = start.parent;
      nodes.push(start);
    }
    var k = nodes.length;
    while (end !== ancestor) {
      nodes.splice(k, 0, end);
      end = end.parent;
    }
    return nodes;
  }

  function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(),
        bNodes = b.ancestors(),
        c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while (a === b) {
      c = a;
      a = aNodes.pop();
      b = bNodes.pop();
    }
    return c;
  }

  function node_ancestors() {
    var node = this, nodes = [node];
    while (node = node.parent) {
      nodes.push(node);
    }
    return nodes;
  }

  function node_descendants() {
    return Array.from(this);
  }

  function node_leaves() {
    var leaves = [];
    this.eachBefore(function(node) {
      if (!node.children) {
        leaves.push(node);
      }
    });
    return leaves;
  }

  function node_links() {
    var root = this, links = [];
    root.each(function(node) {
      if (node !== root) { // Don’t include the root’s parent, if any.
        links.push({source: node.parent, target: node});
      }
    });
    return links;
  }

  function* node_iterator() {
    var node = this, current, next = [node], children, i, n;
    do {
      current = next.reverse(), next = [];
      while (node = current.pop()) {
        yield node;
        if (children = node.children) {
          for (i = 0, n = children.length; i < n; ++i) {
            next.push(children[i]);
          }
        }
      }
    } while (next.length);
  }

  function hierarchy(data, children) {
    if (data instanceof Map) {
      data = [undefined, data];
      if (children === undefined) children = mapChildren;
    } else if (children === undefined) {
      children = objectChildren;
    }

    var root = new Node(data),
        node,
        nodes = [root],
        child,
        childs,
        i,
        n;

    while (node = nodes.pop()) {
      if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for (i = n - 1; i >= 0; --i) {
          nodes.push(child = childs[i] = new Node(childs[i]));
          child.parent = node;
          child.depth = node.depth + 1;
        }
      }
    }

    return root.eachBefore(computeHeight);
  }

  function node_copy() {
    return hierarchy(this).eachBefore(copyData);
  }

  function objectChildren(d) {
    return d.children;
  }

  function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
  }

  function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
  }

  function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && (node.height < ++height));
  }

  function Node(data) {
    this.data = data;
    this.depth =
    this.height = 0;
    this.parent = null;
  }

  Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: node_count,
    each: node_each,
    eachAfter: node_eachAfter,
    eachBefore: node_eachBefore,
    find: node_find,
    sum: node_sum,
    sort: node_sort,
    path: node_path,
    ancestors: node_ancestors,
    descendants: node_descendants,
    leaves: node_leaves,
    links: node_links,
    copy: node_copy,
    [Symbol.iterator]: node_iterator
  };

  function optional(f) {
    return f == null ? null : required(f);
  }

  function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
  }

  var preroot = {depth: -1},
      ambiguous = {},
      imputed = {};

  function defaultId(d) {
    return d.id;
  }

  function defaultParentId(d) {
    return d.parentId;
  }

  function stratify() {
    var id = defaultId,
        parentId = defaultParentId,
        path;

    function stratify(data) {
      var nodes = Array.from(data),
          currentId = id,
          currentParentId = parentId,
          n,
          d,
          i,
          root,
          parent,
          node,
          nodeId,
          nodeKey,
          nodeByKey = new Map;

      if (path != null) {
        const I = nodes.map((d, i) => normalize(path(d, i, data)));
        const P = I.map(parentof);
        const S = new Set(I).add("");
        for (const i of P) {
          if (!S.has(i)) {
            S.add(i);
            I.push(i);
            P.push(parentof(i));
            nodes.push(imputed);
          }
        }
        currentId = (_, i) => I[i];
        currentParentId = (_, i) => P[i];
      }

      for (i = 0, n = nodes.length; i < n; ++i) {
        d = nodes[i], node = nodes[i] = new Node(d);
        if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
          nodeKey = node.id = nodeId;
          nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
        }
        if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) {
          node.parent = nodeId;
        }
      }

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        if (nodeId = node.parent) {
          parent = nodeByKey.get(nodeId);
          if (!parent) throw new Error("missing: " + nodeId);
          if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
          if (parent.children) parent.children.push(node);
          else parent.children = [node];
          node.parent = parent;
        } else {
          if (root) throw new Error("multiple roots");
          root = node;
        }
      }

      if (!root) throw new Error("no root");

      // When imputing internal nodes, only introduce roots if needed.
      // Then replace the imputed marker data with null.
      if (path != null) {
        while (root.data === imputed && root.children.length === 1) {
          root = root.children[0], --n;
        }
        for (let i = nodes.length - 1; i >= 0; --i) {
          node = nodes[i];
          if (node.data !== imputed) break;
          node.data = null;
        }
      }

      root.parent = preroot;
      root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
      root.parent = null;
      if (n > 0) throw new Error("cycle");

      return root;
    }

    stratify.id = function(x) {
      return arguments.length ? (id = optional(x), stratify) : id;
    };

    stratify.parentId = function(x) {
      return arguments.length ? (parentId = optional(x), stratify) : parentId;
    };

    stratify.path = function(x) {
      return arguments.length ? (path = optional(x), stratify) : path;
    };

    return stratify;
  }

  // To normalize a path, we coerce to a string, strip the trailing slash if any
  // (as long as the trailing slash is not immediately preceded by another slash),
  // and add leading slash if missing.
  function normalize(path) {
    path = `${path}`;
    let i = path.length;
    if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
  }

  // Walk backwards to find the first slash that is not the leading slash, e.g.:
  // "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
  // because the id of the root must be a truthy value.)
  function parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while (--i > 1) if (slash(path, i)) break;
    return path.slice(0, i);
  }

  // Slashes can be escaped; to determine whether a slash is a path delimiter, we
  // count the number of preceding backslashes escaping the forward slash: an odd
  // number indicates an escaped forward slash.
  function slash(path, i) {
    if (path[i] === "/") {
      let k = 0;
      while (i > 0 && path[--i] === "\\") ++k;
      if ((k & 1) === 0) return true;
    }
    return false;
  }

  /**
   * Resolves the value at the given JSON path
   * @private
   * @param  {String} path [description]
   * @param  {Object} obj  [description]
   * @return {Object}      [description]
   *
   * @example
   * let path = "/path/to/paradise";
   * let obj = {
   *   path: {
   *     to: { paradise: "heaven"},
   *     from: {...}
   *   }
   * };
   * resolve( path, obj ); // "heaven"
   */
  function resolve(path, obj) {
    if (path.charAt(0) === '/') {
      path = path.substring(1);
    }
    const arr = path.split('/');
    let subpath;
    let container = obj;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === '*' && Array.isArray(container)) {
        const carr = [];
        subpath = arr.slice(i + 1).join('/');
        for (let c = 0; c < container.length; c++) {
          let v = resolve(subpath, container[c]);
          // v.forEach(_ => _._parent = container[c]);
          if (Array.isArray(v)) {
            carr.push(...v);
          } else {
            carr.push(v);
          }
        }
        return carr;
        // return container.map(v => resolve(arr.slice(i + 1).join('/'), v));
      }
      if (!arr[i] && Array.isArray(container)) {
        const carr = new Array(container.length);
        subpath = arr.slice(i + 1).join('/');
        for (let c = 0; c < container.length; c++) {
          carr[c] = resolve(subpath, container[c]);
        }
        return carr;
        // return container.map(v => resolve(arr.slice(i + 1).join('/'), v));
      }
      if (arr[i] in container) {
        container = container[arr[i]];
      }
    }
    return container;
  }

  function flattenTree(children, steps, arrIndexAtTargetDepth) {
    let arr = [];
    if (!children || !children.length) {
      return arr;
    }
    if (steps <= 0) {
      const nodes = arrIndexAtTargetDepth >= 0 ? [children[arrIndexAtTargetDepth]] : children;
      arr = [...arr, ...nodes];
    } else {
      for (let i = 0; i < children.length; i++) {
        if (children[i].children && children[i].children.length) {
          arr = [...arr, ...flattenTree(children[i].children, steps - 1, arrIndexAtTargetDepth)];
        }
      }
    }
    return arr;
  }
  function treeAccessor(sourceDepth, targetDepth, arrIndexAtTargetDepth) {
    if (sourceDepth === targetDepth) {
      return d => d;
    }
    if (sourceDepth > targetDepth) {
      // traverse upwards
      const steps = Math.max(0, Math.min(100, sourceDepth - targetDepth));
      return node => {
        let n = node;
        for (let i = 0; i < steps; ++i) {
          n = n.parent;
        }
        return n;
      };
    }
    if (targetDepth > sourceDepth) {
      // flatten descendants
      const steps = Math.max(0, Math.min(100, targetDepth - sourceDepth));
      return node => flattenTree(node.children, steps - 1, arrIndexAtTargetDepth);
    }
    return false;
  }
  function findField(query, _ref) {
    let {
      cache
    } = _ref;
    if (typeof query === 'number') {
      return cache.fields[query];
    }
    const allFields = cache.allFields;
    if (typeof query === 'function') {
      for (let i = 0; i < allFields.length; i++) {
        if (query(allFields[i])) {
          return allFields[i];
        }
      }
      return false;
    }
    if (typeof query === 'string') {
      for (let i = 0; i < allFields.length; i++) {
        if (allFields[i].key() === query || allFields[i].title() === query) {
          return allFields[i];
        }
      }
    } else if (query && allFields.indexOf(query) !== -1) {
      // assume 'query' is a field instance
      return query;
    }
    throw Error("Field not found: ".concat(query));
  }

  const DIM_RX$1 = /^qDimensionInfo(?:\/(\d+))?/;
  const M_RX$1 = /^\/?qMeasureInfo\/(\d+)/;
  const ATTR_EXPR_RX$1 = /\/qAttrExprInfo\/(\d+)/;
  const ATTR_DIM_RX$1 = /\/qAttrDimInfo\/(\d+)/;
  function getColumnOrder(dataset) {
    const qColumnOrder = dataset.raw().qColumnOrder;
    const fields = dataset.fields();
    return qColumnOrder && qColumnOrder.length === fields.length ? qColumnOrder : fields.map((f, i) => i);
  }
  function getDimensionColumnOrder(cube) {
    const order = cube.qColumnOrder && cube.qColumnOrder.length ? cube.qColumnOrder : cube.qDimensionInfo.map((d, ii) => ii);
    return order.filter(ii => ii < cube.qDimensionInfo.length);
  }
  function getFieldDepth(field, _ref) {
    let {
      cube
    } = _ref;
    if (!field) {
      return -1;
    }
    let key = field.origin && field.origin() ? field.origin().key() : field.key();
    let isFieldDimension = false;
    let fieldIdx = -1; // cache.fields.indexOf(field);
    let attrIdx = -1;
    let attrDimIdx = -1;
    let fieldDepth = -1;
    let pseudoMeasureIndex = -1;
    let measureIdx = -1;
    let remainder = key;
    const treeOrder = cube.qEffectiveInterColumnSortOrder;
    const columnOrder = getDimensionColumnOrder(cube);
    if (DIM_RX$1.test(remainder)) {
      isFieldDimension = true;
      fieldIdx = +DIM_RX$1.exec(remainder)[1];
      remainder = key.replace(DIM_RX$1, '');
    }
    if (M_RX$1.test(remainder)) {
      if (cube.qMode === 'K') {
        pseudoMeasureIndex = +M_RX$1.exec(remainder)[1];
      } else if (treeOrder && treeOrder.indexOf(-1) !== -1) {
        pseudoMeasureIndex = +M_RX$1.exec(remainder)[1];
        measureIdx = 0;
      } else {
        measureIdx = +M_RX$1.exec(remainder)[1];
      }
      remainder = remainder.replace(M_RX$1, '');
    }
    if (remainder) {
      if (ATTR_DIM_RX$1.exec(remainder)) {
        attrDimIdx = +ATTR_DIM_RX$1.exec(remainder)[1];
      } else if (ATTR_EXPR_RX$1.exec(remainder)) {
        attrIdx = +ATTR_EXPR_RX$1.exec(remainder)[1];
      }
    }
    if (isFieldDimension) {
      if (cube.qMode === 'S') {
        fieldDepth = columnOrder[fieldIdx];
      } else {
        fieldDepth = treeOrder ? treeOrder.indexOf(fieldIdx) : fieldIdx;
      }
    } else if (treeOrder && treeOrder.indexOf(-1) !== -1) {
      // if pseudo dimension exists in sort order
      fieldDepth = treeOrder.indexOf(-1); // depth of pesudodimension
    } else {
      // assume measure is at the bottom of the tree
      fieldDepth = cube.qDimensionInfo.length - (cube.qMode === 'K' ? 0 : 1);
    }
    return {
      fieldDepth: fieldDepth + 1,
      // +1 due to root node
      pseudoMeasureIndex,
      measureIdx,
      attrDimIdx,
      attrIdx
    };
  }
  function getFieldAccessor(sourceDepthObject, targetDepthObject) {
    let nodeFn = treeAccessor(sourceDepthObject.fieldDepth, targetDepthObject.fieldDepth, targetDepthObject.pseudoMeasureIndex);
    let valueFn;
    if (targetDepthObject.measureIdx >= 0) {
      valueFn = node => node.data.qValues[targetDepthObject.measureIdx];
    } else {
      valueFn = node => node.data;
    }
    let attrFn;
    if (targetDepthObject.attrDimIdx >= 0) {
      attrFn = data => {
        var _data$qAttrDims;
        return data === null || data === void 0 || (_data$qAttrDims = data.qAttrDims) === null || _data$qAttrDims === void 0 ? void 0 : _data$qAttrDims.qValues[targetDepthObject.attrDimIdx];
      };
    } else if (targetDepthObject.attrIdx >= 0) {
      attrFn = data => {
        var _data$qAttrExps;
        return data === null || data === void 0 || (_data$qAttrExps = data.qAttrExps) === null || _data$qAttrExps === void 0 ? void 0 : _data$qAttrExps.qValues[targetDepthObject.attrIdx];
      };
    }
    return {
      nodeFn,
      attrFn,
      valueFn
    };
  }
  function datumExtract(propCfg, cell, _ref2) {
    let {
      key
    } = _ref2;
    const datum = {
      value: typeof propCfg.value === 'function' ? propCfg.value(cell) : typeof propCfg.value !== 'undefined' ? propCfg.value : cell // eslint-disable-line no-nested-ternary
    };
    datum.label = typeof propCfg.label === 'function' ? propCfg.label(cell) : typeof propCfg.label !== 'undefined' ? String(propCfg.label) : String(datum.value); // eslint-disable-line no-nested-ternary

    if (propCfg.field) {
      datum.source = {
        key,
        field: propCfg.field.key()
      };
    }
    return datum;
  }
  function doIt(_ref3) {
    let {
      propsArr,
      props,
      item,
      itemData,
      ret,
      sourceKey
    } = _ref3;
    for (let i = 0; i < propsArr.length; i++) {
      const pCfg = props[propsArr[i]];
      const arr = pCfg.fields || [pCfg];
      let coll;
      let collStr;
      if (pCfg.fields) {
        coll = [];
        collStr = [];
      }
      for (let j = 0; j < arr.length; j++) {
        const p = arr[j];
        let fn;
        let str;
        let value;
        let nodes;
        let cells;
        let label;
        if (p.type === 'primitive') {
          value = p.value;
          label = String(p.value);
        } else {
          if (typeof p.value === 'function') {
            fn = v => p.value(v, item);
          }
          if (typeof p.label === 'function') {
            str = v => p.label(v, item);
          }
          if (p.accessor) {
            nodes = p.accessor(item);
            if (Array.isArray(nodes)) {
              // propably descendants
              cells = nodes.map(p.valueAccessor);
              if (p.attrAccessor) {
                cells = cells.map(p.attrAccessor);
              }
              if (fn) {
                value = cells.map(fn);
                fn = null;
              }
              if (str) {
                label = cells.map(str);
                str = null;
              }
              value = p.reduce ? p.reduce(value) : value;
              label = p.reduceLabel ? p.reduceLabel(label, value) : String(value);
            } else {
              value = p.attrAccessor ? p.attrAccessor(p.valueAccessor(nodes)) : p.valueAccessor(nodes);
              label = value;
            }
          } else {
            value = itemData;
            label = itemData;
          }
        }
        if (pCfg.fields) {
          const v = fn ? fn(value) : value;
          coll.push(v);
          collStr.push(str && label != null ? str(label) : label != null ? label : String(v));
        } else {
          const v = fn ? fn(value) : value;
          ret[propsArr[i]] = {
            value: v,
            label: str ? str(label) : label != null ? label : String(v)
          };
          if (p.field) {
            ret[propsArr[i]].source = {
              field: p.field.key(),
              key: sourceKey
            };
          }
        }
      }
      if (coll) {
        ret[propsArr[i]] = {
          value: typeof pCfg.value === 'function' ? pCfg.value(coll, item) : coll,
          label: typeof pCfg.label === 'function' ? pCfg.label(collStr, item) : collStr
        };
      }
    }
  }
  const getHierarchy = (cube, cache, config) => {
    const rootPath = cube.qMode === 'K' ? '/qStackedDataPages/*/qData' : '/qTreeDataPages/*';
    const childNodes = cube.qMode === 'K' ? 'qSubNodes' : 'qNodes';
    const root = resolve(rootPath, cube);
    if (!root || !root[0]) {
      return null;
    }
    cache.tree = hierarchy(root[0], config.children || (node => node[childNodes]));
    return cache.tree;
  };
  function getHierarchyForSMode(dataset) {
    const matrix = dataset.raw().qDataPages.length ? dataset.raw().qDataPages[0].qMatrix : [];
    const order = getColumnOrder(dataset);
    const fields = dataset.fields();
    const dimensions = dataset.fields().filter(f => f.type() === 'dimension').map(f => order.indexOf(fields.indexOf(f)));
    const measures = dataset.fields().filter(f => f.type() === 'measure').map(f => order.indexOf(fields.indexOf(f)));
    const root = {
      __id: '__root',
      qValues: []
    };
    const keys = {
      __root: root
    };
    for (let r = 0; r < matrix.length; r++) {
      const row = matrix[r];
      let id = '__root';
      // let parent = root;
      let isNew = false;
      for (let c = 0; c < dimensions.length; c++) {
        var _cell$qElemNumber;
        const cell = row[dimensions[c]];
        const key = "".concat(id, "__").concat((_cell$qElemNumber = cell.qElemNumber) !== null && _cell$qElemNumber !== void 0 ? _cell$qElemNumber : cell.qElemNo);
        if (!keys[key]) {
          keys[key] = _objectSpread2({
            __id: key,
            __parent: id,
            qValues: []
          }, cell);
          isNew = true;
        }
        id = key;
      }
      if (isNew) {
        for (let c = 0; c < measures.length; c++) {
          const cell = row[measures[c]];
          keys[id].qValues.push(cell);
        }
      }
    }
    const nodes = Object.keys(keys).map(key => keys[key]);
    const h = stratify().id(d => d.__id).parentId(d => d.__parent)(nodes);
    return h;
  }
  const attachPropsAccessors = _ref4 => {
    let {
      propsArr,
      props,
      cube,
      cache,
      itemDepthObject,
      f
    } = _ref4;
    for (let i = 0; i < propsArr.length; i++) {
      const pCfg = props[propsArr[i]];
      const arr = pCfg.fields ? pCfg.fields : [pCfg];
      for (let j = 0; j < arr.length; j++) {
        const p = arr[j];
        if (p.field !== f) {
          const depthObject = getFieldDepth(p.field, {
            cube,
            cache
          });
          const accessors = getFieldAccessor(itemDepthObject, depthObject);
          p.accessor = accessors.nodeFn; // nodes accessor
          p.valueAccessor = accessors.valueFn; // cell accessor
          p.attrAccessor = accessors.attrFn; // attr cell accessor
        }
      }
    }
  };
  function augment() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let dataset = arguments.length > 1 ? arguments[1] : undefined;
    let cache = arguments.length > 2 ? arguments[2] : undefined;
    let util = arguments.length > 3 ? arguments[3] : undefined;
    const cube = dataset.raw();
    const sourceKey = dataset.key();
    const h = cube.qMode === 'S' ? getHierarchyForSMode(dataset) : getHierarchy(cube, cache, config);
    if (!h) {
      return null;
    }
    const height = h.height;
    const propDefs = [];
    for (let i = 0; i <= height; i++) {
      let f = null;
      if (i > 0) {
        if (cube.qMode === 'S') {
          const order = getDimensionColumnOrder(cube);
          let idx = order[i - 1];
          f = cache.fields[idx];
        } else {
          let idx = cube.qEffectiveInterColumnSortOrder[i - 1];
          // if (idx === -1) { // pseudo
          //   let childIdx = node.parent.children.indexOf(node);
          //   idx = cube.qDimensionInfo.length + childIdx; // measure field
          // }
          if (i > cube.qEffectiveInterColumnSortOrder.length) {
            idx = cube.qDimensionInfo.length;
          }
          f = cache.fields[idx];
        }
      }
      const {
        props,
        main
      } = util.normalizeConfig(_objectSpread2(_objectSpread2({}, config), {}, {
        field: f ? f.key() : undefined
      }), dataset);
      const propsArr = Object.keys(props);
      propDefs[i] = {
        propsArr,
        props,
        main
      };
      const itemDepthObject = f ? getFieldDepth(f, {
        cube,
        cache
      }) : {
        fieldDepth: 0
      };
      attachPropsAccessors({
        propsArr,
        props,
        cube,
        cache,
        itemDepthObject,
        f
      });
    }
    const replica = h.copy();
    const replicaDescendants = replica.descendants();
    const descendants = h.descendants();
    for (let i = 0; i < descendants.length; i++) {
      const propsArr = propDefs[descendants[i].depth].propsArr;
      const props = propDefs[descendants[i].depth].props;
      const main = propDefs[descendants[i].depth].main;
      const item = replicaDescendants[i];
      const itemData = item.data; // main.valueAccessor(currentOriginal);

      const ret = datumExtract(main, itemData, {
        key: sourceKey
      });
      doIt({
        propsArr,
        props,
        item,
        itemData,
        ret,
        sourceKey,
        isTree: true
      });
      descendants[i].data = ret;
    }
    return h;
  }
  function extract(config, dataset, cache, util) {
    const cfgs = Array.isArray(config) ? config : [config];
    let dataItems = [];
    for (let g = 0; g < cfgs.length; g++) {
      if (typeof cfgs[g].field !== 'undefined') {
        const cube = dataset.raw();
        const sourceKey = dataset.key();
        const h = getHierarchy(cube, cache, config);
        if (!h) {
          continue;
        }
        const f = typeof cfgs[g].field === 'object' ? cfgs[g].field : dataset.field(cfgs[g].field);
        const {
          props,
          main
        } = util.normalizeConfig(cfgs[g], dataset);
        const propsArr = Object.keys(props);
        const itemDepthObject = getFieldDepth(f, {
          cube,
          cache
        });
        const {
          nodeFn,
          attrFn,
          valueFn
        } = getFieldAccessor({
          fieldDepth: 0
        }, itemDepthObject);
        attachPropsAccessors({
          propsArr,
          props,
          cube,
          cache,
          itemDepthObject,
          f
        });
        const track = !!cfgs[g].trackBy;
        const trackType = typeof cfgs[g].trackBy;
        const tracker = {};
        const trackedItems = [];
        const items = nodeFn(cache.tree);
        const mapped = [];
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const itemData = attrFn ? attrFn(valueFn(item)) : valueFn(item);
          const exclude = main.filter && !main.filter(itemData);
          if (exclude) {
            continue;
          }
          const ret = datumExtract(main, itemData, {
            key: sourceKey
          });
          doIt({
            propsArr,
            props,
            item,
            itemData,
            ret,
            sourceKey
          });
          // collect items based on the trackBy value
          // items with the same trackBy value are placed in an array and reduced later
          if (track) {
            util.track({
              cfg: cfgs[g],
              itemData,
              obj: ret,
              target: trackedItems,
              tracker,
              trackType
            });
          }
          mapped.push(ret);
        }
        // reduce if items have been grouped
        const tmp = track ? util.collect(trackedItems, {
          main,
          propsArr,
          props
        }) : mapped;
        dataItems = [...dataItems, ...tmp];
      }
    }
    return dataItems;
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var format_min = createCommonjsModule(function (module) {
  /*! javascript-number-formatter - v1.1.11 - http://mottie.github.com/javascript-number-formatter/ * © ecava */
  !function(a,b){module.exports=b();}(commonjsGlobal,function(){return function(a,b){if(!a||isNaN(+b))return b;var c,d,e,f,g,h,i,j,k,l,m=a.length,n=a.search(/[0-9\-\+#]/),o=n>0?a.substring(0,n):"",p=a.split("").reverse().join(""),q=p.search(/[0-9\-\+#]/),r=m-q,s=a.substring(r,r+1),t=r+("."===s||","===s?1:0),u=q>0?a.substring(t,m):"";if(a=a.substring(n,t),b="-"===a.charAt(0)?-b:+b,c=b<0?b=-b:0,d=a.match(/[^\d\-\+#]/g),e=d&&d[d.length-1]||".",f=d&&d[1]&&d[0]||",",a=a.split(e),b=b.toFixed(a[1]&&a[1].length),b=+b+"",h=a[1]&&a[1].lastIndexOf("0"),j=b.split("."),(!j[1]||j[1]&&j[1].length<=h)&&(b=(+b).toFixed(h+1)),k=a[0].split(f),a[0]=k.join(""),g=a[0]&&a[0].indexOf("0"),g>-1)for(;j[0].length<a[0].length-g;)j[0]="0"+j[0];else 0===+j[0]&&(j[0]="");if(b=b.split("."),b[0]=j[0],i=k[1]&&k[k.length-1].length){for(l=b[0],p="",r=l.length%i,m=l.length,t=0;t<m;t++)p+=l.charAt(t),!((t-r+1)%i)&&t<m-i&&(p+=f);b[0]=p;}return b[1]=a[1]&&b[1]?e+b[1]:"",d=b.join(""),"0"!==d&&""!==d||(c=!1),o+((c?"-":"")+d)+u}});
  });

  // 1.95.toFixed(1) = 1.9
  // 2.95.toFixed(1) = 3.0
  const EPSILON = 1e-15; // To make sure toFixed always round up.

  function escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  }
  const SIprefixes = {
      3: 'k',
      6: 'M',
      9: 'G',
      12: 'T',
      15: 'P',
      18: 'E',
      21: 'Z',
      24: 'Y',
      '-3': 'm',
      '-6': 'μ',
      '-9': 'n',
      '-12': 'p',
      '-15': 'f',
      '-18': 'a',
      '-21': 'z',
      '-24': 'y'
    },
    percentage = /%\)?$/,
    //    scientific = /e[\+\-][0-9]+/,
    radix = /^\(r(0[2-9]|[12]\d|3[0-6])\)/i,
    oct = /^\(oct\)/i,
    dec = /^\(dec\)/i,
    hex = /^\(hex\)/i,
    bin = /^\(bin\)/i,
    rom = /^\(rom\)/i,
    functional = /^(\(rom\)|\(bin\)|\(hex\)|\(dec\)|\(oct\)|\(r(0[2-9]|[12]\d|3[0-6])\))/i,
    prec = /#|0/g;
  function formatRadix(value, fradix, pattern, decimal) {
    value = value.toString(fradix);
    if (pattern[1] === pattern[1].toUpperCase()) {
      value = value.toUpperCase();
    }
    if (value.length - value.indexOf('.') > 10) {
      // limit to 10 decimal places
      value = value.slice(0, value.indexOf('.') + 11);
    }
    return value.replace('.', decimal || '.');
  }

  // value must be an integer
  // value must not be in scientific notation
  function formatRoman(value, pattern) {
    let i,
      s = '',
      v = Number(String(value).slice(-3)),
      nThousands = (value - v) / 1000,
      decimal = [0, 1, 4, 5, 9, 10, 40, 50, 90, 100, 400, 500, 900].reverse(),
      numeral = ['0', 'I', 'IV', 'V', 'IX', 'X', 'XL', 'L', 'XC', 'C', 'CD', 'D', 'CM'].reverse();
    while (v > 0) {
      for (i = 0; i < decimal.length; i++) {
        if (decimal[i] <= v) {
          s += numeral[i];
          v -= decimal[i];
          break;
        }
      }
    }
    for (i = 0; i < nThousands; i++) {
      s = "M".concat(s);
    }
    if (pattern[1] !== pattern[1].toUpperCase()) {
      s = s.toLowerCase();
    }
    return s;
  }
  function formatFunctional(value, pattern, d) {
    let temp;
    if (radix.test(pattern)) {
      value = formatRadix(value, Number(/\d{2}/.exec(pattern)[0]), pattern, d);
    } else if (oct.test(pattern)) {
      value = formatRadix(value, 8, pattern, d);
    } else if (dec.test(pattern)) {
      value = formatRadix(value, 10, pattern, d);
    } else if (hex.test(pattern)) {
      value = formatRadix(value, 16, pattern, d);
    } else if (bin.test(pattern)) {
      value = formatRadix(value, 2, pattern, d);
    } else if (rom.test(pattern)) {
      temp = '';
      if (value < 0) {
        temp = '-';
        value = -value;
      }
      value = Math.floor(value);
      if (value === 0) {
        value = '0';
      } else if (value <= 500000) {
        // limit in engine
        value = formatRoman(value, pattern);
        value = temp + value;
      } else {
        value = pattern + temp + value.toExponential(0); // to return same result as engine
      }
    }
    return value;
  }
  function escape(value, flags, justStr) {
    const str = escapeRegExp(value);
    if (justStr) {
      return str;
    }
    return new RegExp(str || '', flags);
  }
  function createRegExp(thousand, decimal) {
    if (decimal) {
      decimal = escapeRegExp(decimal);
    }
    if (thousand) {
      thousand = escapeRegExp(thousand);
    }
    return new RegExp("(?:[#0]+".concat(thousand, ")?[#0]+(?:").concat(decimal, "[#0]+)?"));
  }
  function getAbbreviations(localeInfo, listSeparator) {
    if (!localeInfo || !localeInfo.qNumericalAbbreviation) {
      return SIprefixes;
    }
    const abbreviations = {};
    let abbrs = localeInfo.qNumericalAbbreviation.split(listSeparator);
    abbrs.forEach(abbreviation => {
      let abbreviationTuple = abbreviation.split(':');
      if (abbreviationTuple.length === 2) {
        abbreviations[abbreviationTuple[0]] = abbreviationTuple[1];
      }
    });
    return abbreviations;
  }
  function preparePattern(o, t, d, abbreviate) {
    let parts,
      lastPart,
      pattern = o.pattern,
      numericPattern,
      prefix,
      postfix,
      groupTemp,
      decTemp,
      temp,
      regex;
    if (abbreviate) {
      o.abbreviate = true;
    }

    // extract the numeric part from the pattern
    regex = createRegExp(t, d);
    numericPattern = pattern.match(regex);
    numericPattern = numericPattern ? numericPattern[0] : '';
    prefix = numericPattern ? pattern.substr(0, pattern.indexOf(numericPattern)) : pattern;
    postfix = numericPattern ? pattern.substring(pattern.indexOf(numericPattern) + numericPattern.length) : '';
    if (!numericPattern) {
      numericPattern = pattern ? '#' : '##########';
    }
    if (t && t === d) {
      // ignore grouping if grouping separator is same as decimal separator
      // extract decimal part
      parts = numericPattern.split(d);
      lastPart = parts.pop();
      numericPattern = parts.join('') + d + lastPart;
      t = '';
    }

    // formatting library does not support multiple characters as separator (nor +-).
    // do a temporary replacement
    groupTemp = t;
    t = /,/.test(d) ? '¤' : ',';
    if (groupTemp) {
      numericPattern = numericPattern.replace(escape(groupTemp, 'g'), t);
    }
    decTemp = d;
    d = '.';
    if (decTemp) {
      numericPattern = numericPattern.replace(escape(decTemp, 'g'), d);
    }
    temp = numericPattern.match(/#/g);
    temp = temp ? temp.length : 0;
    const splitPattern = pattern.split(decTemp);
    let matchPrecisionResult;
    if (splitPattern[1]) {
      matchPrecisionResult = splitPattern[1].match(prec);
    }
    o.prefix = prefix || '';
    o.postfix = postfix || '';
    o.pattern = pattern;
    o.maxPrecision = matchPrecisionResult ? matchPrecisionResult.length : 2;
    o.percentage = percentage.test(pattern);
    o.numericPattern = numericPattern || '';
    o.numericRegex = new RegExp("".concat(escape(t, null, true), "|").concat(escape(d, null, true)), 'g');
    o.groupTemp = groupTemp;
    o.decTemp = decTemp;
    o.t = t;
    o.d = d;
    o.temp = temp;
  }
  class NumberFormatter {
    /**
     * @name NumberFormatter
     * @constructs
     * @param {Object} localeInfo
     * @param {String} pattern
     * @param {String} [thousand]
     * @param {String} [decimal]
     * @param {String} [type]
     */
    constructor(localeInfo, pattern, thousand, decimal, type) {
      this.localeInfo = localeInfo;
      this.pattern = pattern;
      this.thousandDelimiter = thousand || ',';
      this.decimalDelimiter = decimal || '.';
      this.type = type || 'numeric';

      // FIXME qListSep?
      // this.patternSeparator = this.localeInfo && this.localeInfo.qListSep ? this.localeInfo.qListSep : ';';
      this.patternSeparator = ';';
      this.abbreviations = getAbbreviations(localeInfo, this.patternSeparator);
      this.prepare();
    }
    clone() {
      const n = new NumberFormatter(this.localeInfo, this.pattern, this.thousandDelimiter, this.decimalDelimiter, this.type);
      n.subtype = this.subtype;
      return n;
    }

    /**
     * Formats a number according to a specific pattern.
     * Use # for optional numbers and 0 for padding.
     * @param {Number} value Number to format.
     * @param {String} [pattern] The pattern to apply.
     * @param {String} [t] Grouping separator.
     * @param {String} [d] Decimal delimiter.
     * @example
     * format(10, "0") // 10;
     * format(10, "#") // 10;
     * format(10, "##.#") // 10;
     * format(10, "##.0") // 10.0;
     * format(10, "000") // 010;
     * format(10.123, "0.0") // 10.1;
     * format(10.123, "0.00##") // 10.123; // at least 2 decimals, never more than 4
     * format(123456789, "#,###") // 123,456,789;
     * format(123456789, "####-####", "-") // 1-2345-6789;
     *
     * format(0.257, "0.0%") // 25.7%; // will multiply by 100
     * format(9876, "$#,###") // $9,876;
     * format(-9876, "$#,###;$(#,###)") // $(9,876); // use ; for alternative formatting for negative values
     * format(10, "(r16)") // a; // radix 16
     * format(15, "(hex)") // f; // same as (r16)
     * format(15, "(HEX)") // F;
     * format(10, "(bin)") // 1010; // same as (r02)
     * format(10, "(oct)") // 12; // same as (r08)
     */
    format(value, pattern, t, d) {
      this.prepare(pattern, t, d);
      return this.formatValue(value);
    }
    prepare(pattern, t, d) {
      let prep;
      if (typeof pattern === 'undefined') {
        pattern = this.pattern;
      }
      if (typeof t === 'undefined') {
        t = this.thousandDelimiter;
      }
      if (typeof d === 'undefined') {
        d = this.decimalDelimiter;
      }
      if (!pattern) {
        this._prepared = {
          pattern: false
        };
        return;
      }
      this._prepared = {
        positive: {
          d,
          t,
          abbreviate: false,
          isFunctional: false,
          prefix: '',
          postfix: ''
        },
        negative: {
          d,
          t,
          abbreviate: false,
          isFunctional: false,
          prefix: '',
          postfix: ''
        },
        zero: {
          d,
          t,
          abbreviate: false,
          isFunctional: false,
          prefix: '',
          postfix: ''
        }
      };
      prep = this._prepared;
      pattern = pattern.split(this.patternSeparator);
      prep.positive.pattern = pattern[0];
      prep.negative.pattern = pattern[1];
      prep.zero.pattern = pattern[2];
      if (functional.test(pattern[0])) {
        prep.positive.isFunctional = true;
      }
      if (!pattern[1]) {
        prep.negative = false;
      } else if (functional.test(pattern[1])) {
        prep.negative.isFunctional = true;
      }
      if (!pattern[2]) {
        prep.zero = false;
      } else if (functional.test(pattern[2])) {
        prep.zero.isFunctional = true;
      }
      const abbreviate = this.type === 'U';
      if (!prep.positive.isFunctional) {
        preparePattern(prep.positive, t, d, abbreviate);
      }
      if (prep.negative && !prep.negative.isFunctional) {
        preparePattern(prep.negative, t, d, abbreviate);
      }
      if (prep.zero && !prep.zero.isFunctional) {
        preparePattern(prep.zero, t, d, abbreviate);
      }
    }
    formatValue(value) {
      let prep = this._prepared,
        temp,
        exponent,
        abbr = '',
        absValue,
        num,
        sciValue = '',
        d,
        t,
        i,
        numericPattern,
        decimalPartPattern,
        original = value;
      if (isNaN(value)) {
        return "".concat(original);
      }
      value = +value;
      if (prep.pattern === false) {
        return value.toString();
      }
      if (value === 0 && prep.zero) {
        prep = prep.zero;
        return prep.pattern;
      }
      if (value < 0 && prep.negative) {
        prep = prep.negative;
        value = -value;
      } else {
        prep = prep.positive;
      }
      d = prep.d;
      t = prep.t;
      if (prep.isFunctional) {
        value = formatFunctional(value, prep.pattern, d);
      } else {
        if (prep.percentage) {
          value *= 100;
        }
        if (prep.abbreviate) {
          const abbrArray = Object.keys(this.abbreviations).map(key => parseInt(key, 10)).sort((a, b) => a - b);
          let lowerAbbreviation;
          let upperAbbreviation = abbrArray[0];
          i = 0;
          exponent = Number(Number(value).toExponential().split('e')[1]);
          while (upperAbbreviation <= exponent && i < abbrArray.length) {
            i++;
            upperAbbreviation = abbrArray[i];
          }
          if (i > 0) {
            lowerAbbreviation = abbrArray[i - 1];
          }
          let suggestedAbbrExponent;

          // value and lower abbreviation is for values above 10, use the lower (move to the left <==)
          if (lowerAbbreviation && exponent > 0 && lowerAbbreviation > 0) {
            suggestedAbbrExponent = lowerAbbreviation;
            // value and lower abbreviation is for values below 0.1 (move to the right ==>)
          } else if (exponent < 0 && lowerAbbreviation < 0 || !lowerAbbreviation) {
            // upper abbreviation is also for values below 0.1 and precision allows for using the upper abbreviation(move to the right ==>)
            if (upperAbbreviation < 0 && upperAbbreviation - exponent <= prep.maxPrecision) {
              suggestedAbbrExponent = upperAbbreviation;
              // lower abbrevaition is smaller than exponent and we can't get away with not abbreviating
            } else if (lowerAbbreviation <= exponent && !(upperAbbreviation > 0 && -exponent <= prep.maxPrecision)) {
              // (move to left <==)
              suggestedAbbrExponent = lowerAbbreviation;
            }
          }
          if (suggestedAbbrExponent) {
            abbr = this.abbreviations[suggestedAbbrExponent];
            value /= 10 ** suggestedAbbrExponent;
          }
        }
        absValue = Math.abs(value);
        temp = prep.temp;
        numericPattern = prep.numericPattern;
        decimalPartPattern = numericPattern.split(d)[1];
        if (this.type === 'I') {
          value = Math.round(value);
        }
        num = value;
        if (!decimalPartPattern && numericPattern.slice(-1)[0] === '#') {
          if (absValue >= 10 ** temp || absValue < 1 || absValue < 1e-4) {
            if (value === 0) {
              value = '0';
            } else if (absValue < 1e-4 || absValue >= 1e20) {
              // engine always formats values < 1e-4 in scientific form, values >= 1e20 can only be represented in scientific form
              value = num.toExponential(Math.max(1, Math.min(14, temp)) - 1);
              value = value.replace(/\.?0+(?=e)/, '');
              sciValue = '';
            } else {
              value = value.toPrecision(Math.max(1, Math.min(14, temp)));
              if (value.indexOf('.') >= 0) {
                value = value.replace(value.indexOf('e') < 0 ? /0+$/ : /\.?0+(?=e)/, '');
                value = value.replace('.', d);
              }
            }
          } else {
            numericPattern += d;
            temp = Math.max(0, Math.min(20, temp - Math.ceil(Math.log(absValue) / Math.log(10))));
            for (i = 0; i < temp; i++) {
              numericPattern += '#';
            }
            value = format_min(numericPattern, value);
          }
        } else if (absValue >= 1e15 || absValue > 0 && absValue <= 1e-14) {
          value = absValue ? absValue.toExponential(15).replace(/\.?0+(?=e)/, '') : '0';
        } else {
          const sign = value < 0 ? -1 : 1;
          const wholePart = Number((value + EPSILON * sign).toFixed(Math.min(20, decimalPartPattern ? decimalPartPattern.length : 0)).split('.')[0]);
          let wholePartPattern = numericPattern.split(d)[0];
          wholePartPattern += d;
          value = format_min(wholePartPattern, wholePart) || '0';
          if (decimalPartPattern) {
            const nDecimals = Math.max(0, Math.min(14, decimalPartPattern.length)); // the length of e.g. 0000#####
            const nZeroes = decimalPartPattern.replace(/#+$/, '').length;
            let decimalPart = (this.type === 'I' ? 0 : absValue % 1 + EPSILON).toFixed(nDecimals).slice(2).replace(/0+$/, ''); // remove trailing zeroes

            for (i = decimalPart.length; i < nZeroes; i++) {
              decimalPart += '0';
            }
            if (decimalPart) {
              value += d + decimalPart;
            }
          } else if (wholePart === 0) {
            // to avoid "-" being prefixed to value
            num = 0;
          }
        }
        value = value.replace(prep.numericRegex, m => {
          if (m === t) {
            return prep.groupTemp;
          }
          if (m === d) {
            return prep.decTemp;
          }
          return '';
        });
        if (num < 0 && !/^-/.test(value)) {
          value = "-".concat(value);
        }
      }
      return prep.prefix + value + sciValue + abbr + prep.postfix;
    }
    static getStaticFormatter() {
      return {
        prepare() {},
        formatValue(v) {
          return "".concat(v);
        }
      };
    }
  }
  function numberFormatFactory() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new NumberFormatter(...args);
  }

  function memoize(func) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      size = 5000,
      multipleArguments = false,
      toKey = arg => arg
    } = opts;
    let cache = Object.create(null);
    let index = Object.create(null);
    let counter = 0;
    let fifo = 0; // First-In-First-Out index
    let cacher;
    let k;
    if (multipleArguments) {
      cacher = function () {
        k = toKey(...arguments);
        if (cacher.has(k)) {
          return cacher.get(k);
        }
        return cacher.set(k, func(...arguments));
      };
    } else {
      cacher = arg => {
        k = toKey(arg);
        if (cacher.has(k)) {
          return cacher.get(k);
        }
        return cacher.set(k, func(arg));
      };
    }
    cacher.set = (key, val) => {
      if (counter >= size) {
        delete cache[index[fifo]];
        delete index[fifo];
        counter--;
        fifo++;
      }
      cache[key] = val;
      index[counter] = key;
      counter++;
      return val;
    };
    cacher.get = key => cache[key];
    cacher.has = key => key in cache;
    cacher.clear = () => {
      cache = Object.create(null);
      index = Object.create(null);
      counter = 0;
      fifo = 0;
    };
    cacher.size = () => counter;
    return cacher;
  }

  function formatter$1(pattern, thousand, decimal, qType, localeInfo) {
    const qformat = numberFormatFactory(localeInfo, pattern, thousand, decimal, qType);
    const memoized = memoize(qformat.formatValue.bind(qformat), {
      // Handle NaN and cases where toString yields different result than +operator. Ex. a Date.
      toKey: value => isNaN(value) ? value : +value
    });

    /**
     * Format a value according to the specified pattern created at construct
     *
     * @param  {Number} value   The number to be formatted
     * @return {String}         [description]
     */
    function format(value) {
      return memoized(value);
    }

    /**
     * Format a value according to a specific pattern
     * that is not the one specified in the constructor
     *
     * @param  {String} p   Pattern
     * @param  {Number} v   Value
     * @param  {String} t   Thousand
     * @param  {String} d   Decimal
     * @return {String}     Formatted value
     */
    format.format = function formatFn(p, v, t, d) {
      memoized.clear();
      return qformat.format(v, p, t, d);
    };

    /**
     * Change the pattern on existing formatter
     *
     * @param  {String} p     Pattern (optional)
     * @return {String}       Returns the pattern
     */
    format.pattern = function patternFn(p) {
      if (p) {
        memoized.clear();
        qformat.pattern = p;
        qformat.prepare();
      }
      return qformat.pattern;
    };

    /**
     * Set the locale for the formatter
     *
     * @param  {Object} args   Locale object for formatting
     * @return {Undefined}      Returns nothing
     */
    /* format.locale = function( ...args ) {
      locale = formatLocale( ...args );
      d3format = locale.format( pattern );
       return this;
    }; */

    return format;
  }

  /* eslint import/prefer-default-export: 0 */

  const TYPES = {
    AUTO: 'U',
    INTEGER: 'I',
    NUMBER: 'R',
    FIXED_TO: 'F',
    MONEY: 'M',
    DATE: 'D',
    TIME: 'T',
    DATE_TIME: 'TS',
    INTERVAL: 'IV'
  };

  const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const DAYS_ABBR = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const MONTHS_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const SECONDS_PER_DAY = 86400;
  function pad(s, n) {
    for (let i = s.length; i < n; i++) {
      s = "0".concat(s);
    }
    return s;
  }
  function parseDate(d, twelveFormat) {
    let h = d.getUTCHours();
    let day = d.getUTCDay() - 1;
    if (twelveFormat) {
      h %= 12;
      if (!h) {
        // h == 0 -> 12
        h = 12;
      }
    }
    if (day < 0) {
      day = 6;
    }
    return {
      year: d.getUTCFullYear(),
      month: d.getUTCMonth(),
      day,
      date: d.getUTCDate(),
      h,
      m: d.getUTCMinutes(),
      s: d.getUTCSeconds(),
      f: d.getUTCMilliseconds(),
      t: d.getUTCHours() >= 12 ? 'pm' : 'am'
    };
  }
  function getRemainder(value) {
    let s = value.toString().split('.');
    if (s[1]) {
      s = Number("0.".concat(s[1]));
    } else {
      return 0;
    }
    return s;
  }
  function parseIntervalDays(days) {
    const d = days;
    const h = 24 * getRemainder(d);
    const m = 60 * getRemainder(h);
    const s = 60 * getRemainder(m);
    const ms = 1000 * getRemainder(s);
    return {
      d: Math.floor(d),
      h: Math.floor(h),
      m: Math.floor(m),
      s: Math.floor(s),
      f: Math.round(ms)
    };
  }
  function parseInterval(days, pattern) {
    let units = parseIntervalDays(days),
      d = units.d,
      h = units.h,
      m = units.m,
      s = units.s,
      f = units.f,
      w = 0,
      date;
    if (/w+|t+/gi.test(pattern)) {
      date = new Date(Date.UTC(1899, 11, 30 + Math.floor(days), 0, 0, Math.round(SECONDS_PER_DAY * (days - Math.floor(days)))));
      if (isNaN(date.getTime())) {
        date = null;
      }
    }
    if (!/D+/gi.test(pattern)) {
      h += d * 24;
    }
    if (!/h+/gi.test(pattern)) {
      m += h * 60;
    }
    if (!/m+/gi.test(pattern)) {
      s += m * 60;
    }
    if (/w+/gi.test(pattern)) {
      w = date ? date.getDay() - 1 : 0;
      if (w < 0) {
        w = 6;
      }
    }
    let someT = '';
    if (date) {
      someT = date.getUTCHours() >= 12 ? 'pm' : 'am';
    }
    return {
      year: 0,
      month: 0,
      day: w,
      date: d,
      h,
      m,
      s,
      f,
      t: someT
    };
  }
  function getMasks(inst, d) {
    return {
      'Y+|y+': {
        Y: "".concat(Number("".concat(d.year).slice(-2))),
        YY: pad("".concat(d.year).slice(-2), 2),
        YYY: pad("".concat(d.year).slice(-3), 3),
        def(m) {
          // default
          return pad("".concat(d.year), m.length);
        }
      },
      'M+': {
        M: d.month + 1,
        MM: pad("".concat(d.month + 1), 2),
        MMM: inst.locale_months_abbr[d.month],
        def: inst.locale_months[d.month]
      },
      'W+|w+': {
        W: d.day,
        WW: pad("".concat(d.day), 2),
        WWW: inst.locale_days_abbr[d.day],
        def: inst.locale_days[d.day]
      },
      'D+|d+': {
        D: d.date,
        def(m) {
          return pad("".concat(d.date), m.length);
        }
      },
      'h+|H+': {
        h: d.h,
        def(m) {
          return pad("".concat(d.h), m.length);
        }
      },
      'm+': {
        m: d.m,
        def(m) {
          return pad("".concat(d.m), m.length);
        }
      },
      's+|S+': {
        s: d.s,
        def(m) {
          return pad("".concat(d.s), m.length);
        }
      },
      'f+|F+': {
        def(m) {
          let f = "".concat(d.f),
            n = m.length - f.length;
          if (n > 0) {
            for (let i = 0; i < n; i++) {
              f += '0';
            }
          } else if (n < 0) {
            f = f.slice(0, m.length);
          }
          return f;
        }
      },
      't{1,2}|T{1,2}': {
        def(m) {
          let t = d.t;
          if (m[0].toUpperCase() === m[0]) {
            t = t.toUpperCase();
          }
          t = t.slice(0, m.length);
          return t;
        }
      }
    };
  }
  class DateFormatter {
    /**
     * @name DateFormatter
     * @constructs
     * @param {Object} localeInfo
     * @param {String} pattern
     */
    constructor(localeInfo, pattern, qtype) {
      const info = localeInfo || {};
      if (!info.qCalendarStrings) {
        info.qCalendarStrings = {
          qLongDayNames: DAYS,
          qDayNames: DAYS_ABBR,
          qLongMonthNames: MONTHS,
          qMonthNames: MONTHS_ABBR
        };
      }
      this.localeInfo = info;
      this.locale_days = info.qCalendarStrings.qLongDayNames.slice();
      this.locale_days_abbr = info.qCalendarStrings.qDayNames.slice();
      this.locale_months = info.qCalendarStrings.qLongMonthNames.slice();
      this.locale_months_abbr = info.qCalendarStrings.qMonthNames.slice();
      if (!pattern) {
        const patternMap = {
          [TYPES.TIME]: info.qTimeFmt || 'hh:mm:ss',
          [TYPES.DATE]: info.qDateFmt || 'YYYY-MM-DD',
          [TYPES.DATE_TIME]: info.qTimestampFmt || 'YYYY-MM-DD hh:mm:ss'
        };
        pattern = patternMap[qtype];
      }
      this.pattern = pattern;
    }
    clone() {
      const n = new DateFormatter(this.localeInfo, this.pattern);
      n.subtype = this.subtype;
      return n;
    }

    /**
     * Formats a date according to given pattern
     * @param {Date} date The date to format.
     * @param {String} pattern The desired format of the date
     * var d = new Date(2013, 8, 15, 13, 55, 40, 987);
     * var n = new DateFormatter();
     * @example
     * m.format( d, 'YYYY-MM-DD hh:mm:ss.ffff') // 2013-08-15 13:55:40.9870
     * m.format( d, 'h:m:s tt') // 1:55:40 pm
     * m.format( d, 'h:m:s TT') // 1:55:40 PM
     * m.format( d, 'M/D/YYYY') // 8/15/2013
     * m.format( d, 'WWWW DD MMM') // Thursday 15 Aug
     * m.format( d, 'WWW DD MMMM @ hh:mm:ss') // Thu 15 August @ 13:55:40
     */
    format(date, pattern) {
      // Fallback pattern is set in constructor
      if (!pattern) {
        pattern = this.pattern ? this.pattern : 'YYYY-MM-DD hh:mm:ss';
      }
      pattern = pattern.replace(/\[.+]|\[|]/g, '');
      const hasTwelveFlag = /t+/gi.test(pattern);
      let parsedDate;
      if (date instanceof Date) {
        parsedDate = parseDate(date, hasTwelveFlag);
      } else {
        if (date < 0) {
          // parseInterval don't support for negative values
          date = -date;
          pattern = "-".concat(pattern);
        }
        parsedDate = parseInterval(date, pattern);
      }
      // remove [] and everything inside it

      const masks = getMasks(this, parsedDate);
      const masksArr = [];
      for (const mask in masks) {
        if (Object.prototype.hasOwnProperty.call(masks, mask)) {
          masksArr.push(mask);
        }
      }
      const dateTimeRegex = new RegExp(masksArr.join('|'), 'g');
      const result = pattern.replace(dateTimeRegex, m => {
        let r;
        let mask;
        for (mask in masks) {
          if (Object.prototype.hasOwnProperty.call(masks, mask)) {
            r = new RegExp(mask);
            if (r.test(m)) {
              break;
            }
          }
        }
        if (!r) {
          return '';
        }
        let value;
        for (const submask in masks[mask]) {
          if (submask === m || submask.toLowerCase() === m) {
            value = masks[mask][submask];
            if (typeof value === 'undefined') {
              value = masks[mask][submask.toLowerCase()];
            }
            break;
          }
        }
        if (typeof value === 'undefined') {
          value = masks[mask].def;
        }
        if (typeof value === 'function') {
          value = value(m);
        }
        return value;
      });
      return result;
    }
  }
  function dateFormatFactory() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new DateFormatter(...args);
  }

  const MS_PER_DAY = 86400000;
  function QlikTimeToDate(value) {
    return new Date(Date.UTC(1899, 11, 30 + Math.floor(value), 0, 0, 0, Math.round(MS_PER_DAY * (value - Math.floor(value)))));
  }
  function formatter(pattern) {
    let qtype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'TS';
    let localeInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let qformat = dateFormatFactory(localeInfo, pattern, qtype);
    let memoized = memoize(qformat.format.bind(qformat), {
      toKey: date => typeof date === 'object' && typeof date.getTime === 'function' ? date.getTime() : date
    });

    /**
     * Prepare a value according to the specified qtype
     *
     * @param  {Number} value The value to be formatted
     * @return {Number}       The converted value (if applied)
     */
    function prepare(value) {
      if (qtype !== TYPES.INTERVAL) {
        return QlikTimeToDate(value);
      }
      return value;
    }

    /**
     * Format a value according to the specified pattern created at construct
     *
     * @param  {Date} value   The number to be formatted
     * @return {String}         [description]
     */
    function format(value) {
      value = prepare(value);
      return memoized(value);
    }

    /**
     * Format a value according to a specific pattern
     * that is not the one specified in the constructor
     *
     * @param  {String} p   Pattern
     * @param  {Date} v   Value
     * @return {String}     Formatted value
     */
    format.format = function formatFn(p, v) {
      memoized.clear();
      v = prepare(v);
      return qformat.format(v, p);
    };

    /**
     * Set the locale for the formatter
     *
     * @param  {Object} args   Locale object for formatting
     * @return {Undefined}      Returns nothing
     */
    format.locale = function locale(li) {
      qformat = dateFormatFactory(li, pattern, qtype);
      memoized = memoize(qformat.format.bind(qformat), {
        toKey: date => typeof date === 'object' ? date.getTime() : date
      });
      return this;
    };

    /**
     * Get or set the QType
     *
     * @param  {String} nqt New qType (optional)
     * @return {String}     Current qtype
     */
    format.qtype = function qtypeFn(nqt) {
      if (nqt !== undefined) {
        qtype = nqt;
        memoized.clear();
      }
      return qtype;
    };
    return format;
  }

  function createFromMetaInfo(meta, localeInfo) {
    if (meta && meta.qNumFormat && ['D', 'T', 'TS', 'IV'].indexOf(meta.qNumFormat.qType) !== -1) {
      return formatter(meta.qNumFormat.qFmt, meta.qNumFormat.qType, localeInfo);
    }
    let pattern = '#';
    let thousand = localeInfo && typeof localeInfo.qThousandSep !== 'undefined' ? localeInfo.qThousandSep : ',';
    let decimal = localeInfo && typeof localeInfo.qDecimalSep !== 'undefined' ? localeInfo.qDecimalSep : '.';
    let type = 'U';
    let isAuto = meta && !!meta.qIsAutoFormat;
    if (meta && meta.qNumFormat) {
      pattern = meta.qNumFormat.qFmt || pattern;
      thousand = meta.qNumFormat.qThou || thousand;
      decimal = meta.qNumFormat.qDec || decimal;
      type = meta.qNumFormat.qType || type;
      isAuto = isAuto && ['M'].indexOf(meta.qNumFormat.qType) === -1;
    } else {
      isAuto = true;
    }
    if (isAuto || type === 'U') {
      pattern = "#".concat(decimal, "##");
      type = 'U';
    }
    return formatter$1(pattern, thousand, decimal, type, localeInfo);
  }

  function qField() {
    let {
      meta,
      id,
      key,
      localeInfo,
      fieldExtractor,
      value,
      type,
      sourceField
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let values;
    const valueFn = value || (type === 'dimension' ? d => d === null || d === void 0 ? void 0 : d.qElemNo : d => d === null || d === void 0 ? void 0 : d.qValue);
    const labelFn = d => (d === null || d === void 0 ? void 0 : d.qText) || '';
    const reduce = type === 'dimension' ? 'first' : 'avg';
    const formatter = createFromMetaInfo(meta, localeInfo);
    const reduceLabel = type === 'dimension' ? 'first' : (labels, v) => formatter(v);
    const f = {
      id: () => id,
      key: () => key,
      raw: () => meta,
      title: () => meta.qFallbackTitle || meta.label,
      type: () => type,
      origin: () => sourceField,
      items: () => {
        if (!values) {
          values = fieldExtractor(f);
        }
        return values;
      },
      min: () => meta.qMin,
      max: () => meta.qMax,
      value: valueFn,
      label: labelFn,
      reduce,
      reduceLabel,
      formatter: () => formatter,
      tags: () => meta.qTags
    };
    return f;
  }

  function createFields(path, obj, prefix, parentKey, opts) {
    return (obj[path] || []).map((meta, i) => {
      const fieldKey = "".concat(parentKey ? "".concat(parentKey, "/") : '').concat(path, "/").concat(i);
      const f = {
        instance: qField(extend({
          id: "".concat(prefix ? "".concat(prefix, "/") : '').concat(fieldKey),
          key: fieldKey,
          meta
        }, opts))
      };
      f.attrDims = createFields('qAttrDimInfo', meta, prefix, fieldKey, extend({}, opts, {
        value: v => v === null || v === void 0 ? void 0 : v.qElemNo,
        type: 'dimension'
      }));
      f.attrExps = createFields('qAttrExprInfo', meta, prefix, fieldKey, extend({}, opts, {
        value: v => v === null || v === void 0 ? void 0 : v.qNum,
        type: 'measure'
      }));
      f.measures = createFields('qMeasureInfo', meta, prefix, fieldKey, extend({}, opts, {
        value: v => v === null || v === void 0 ? void 0 : v.qValue,
        type: 'measure'
      }));
      return f;
    });
  }
  function q() {
    let {
      key,
      data,
      config = {}
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const cache = {
      fields: [],
      wrappedFields: [],
      allFields: [],
      virtualFields: []
    };
    const cube = data;
    if (!cube) {
      throw new Error('Missing "data" input');
    }
    if (!cube.qDimensionInfo) {
      throw new Error('The "data" input is not recognized as a hypercube');
    }
    const deps = q.util;
    const opts = {
      cache,
      cube,
      localeInfo: config.localeInfo,
      fieldExtractor: null,
      pages: null,
      hierarchy: () => null,
      virtualFields: config.virtualFields
    };
    const dataset = {
      key: () => key,
      raw: () => cube,
      field: query => findField(query, opts),
      fields: () => cache.fields.slice(),
      extract: extractionConfig => opts.extractor(extractionConfig, dataset, cache, deps),
      hierarchy: hierarchyConfig => opts.hierarchy(hierarchyConfig, dataset, cache, deps),
      _cache: () => cache
    };
    if (cube.qMode === 'K' || cube.qMode === 'T' || !cube.qMode && cube.qNodesOnDim) {
      opts.extractor = extract;
      opts.hierarchy = augment;
      opts.pages = cube.qMode === 'K' ? cube.qStackedDataPages : cube.qTreeDataPages;
    } else if (cube.qMode === 'S') {
      opts.extractor = extract$1;
      opts.pages = cube.qDataPages;
      opts.hierarchy = augment;
    } else {
      opts.extractor = () => []; // TODO - throw unsupported error?
    }
    opts.fieldExtractor = f => opts.extractor({
      field: f
    }, dataset, cache, deps);
    const dimAcc = cube.qMode === 'S' ? d => d.qElemNumber : undefined;
    const measAcc = cube.qMode === 'S' ? d => d.qNum : undefined;
    cache.wrappedFields.push(...createFields('qDimensionInfo', cube, key, '', extend({}, opts, {
      value: dimAcc,
      type: 'dimension'
    })));
    cache.wrappedFields.push(...createFields('qMeasureInfo', cube, key, '', extend({}, opts, {
      value: measAcc,
      type: 'measure'
    })));
    cache.fields = cache.wrappedFields.map(f => f.instance);
    const traverse = arr => {
      arr.forEach(f => {
        cache.allFields.push(f.instance);
        traverse(f.measures);
        traverse(f.attrDims);
        traverse(f.attrExps);
      });
    };
    traverse(cache.wrappedFields);
    (config.virtualFields || []).forEach(v => {
      // key: 'temporal',
      // from: 'qDimensionInfo/0',
      // override: {
      //   value: v => v.qNum,
      // },
      const sourceField = dataset.field(v.from);
      const f = qField(_objectSpread2({
        meta: sourceField.raw(),
        id: "".concat(key, "/").concat(v.key),
        sourceField,
        fieldExtractor: ff => opts.extractor({
          field: ff
        }, dataset, cache, deps),
        key: v.key,
        type: sourceField.type(),
        localeInfo: opts.localeInfo,
        value: sourceField.value
      }, v.override || {}));
      cache.virtualFields.push(f);
    });
    cache.allFields.push(...cache.virtualFields);
    return dataset;
  }

  const LAYOUT_TO_PROP = [['qHyperCube', 'qHyperCubeDef'], ['qTreeData', 'qTreeDataDef'], ['qDimensionInfo', 'qDimensions'], ['qMeasureInfo', 'qMeasures'], ['qAttrDimInfo', 'qAttributeDimensions'], ['qAttrExprInfo', 'qAttributeExpressions']];
  const DIM_RX = /\/qDimensionInfo(?:\/(\d+))?/;
  const M_RX = /\/qMeasureInfo\/(\d+)/;
  const ATTR_DIM_RX = /\/qAttrDimInfo\/(\d+)(?:\/(\d+))?/;
  const ATTR_EXPR_RX = /\/qAttrExprInfo\/(\d+)/;
  const HC_RX = /\/?qHyperCube/;
  const TD_RX = /\/?qTreeData/;
  const SHORTEN_HC = path => "".concat(path.substr(0, path.indexOf('/qHyperCubeDef') + 14)); // 14 = length of '/qHyperCubeDef'
  const SHORTEN_TD = path => "".concat(path.substr(0, path.indexOf('/qTreeDataDef') + 13)); // 13 = length of '/qTreeDataDef'

  function extractFieldFromId(id, layout) {
    let path = id;
    let dimensionIdx = -1;
    let measureIdx = -1;
    let pathToCube = '';
    let shortenizer = p => p;
    if (HC_RX.test(id)) {
      pathToCube = "".concat(path.substr(0, path.indexOf('qHyperCube') + 10)); // 10 = length of 'qHyperCube'
      shortenizer = SHORTEN_HC;
    } else if (TD_RX.test(id)) {
      pathToCube = "".concat(path.substr(0, path.indexOf('qTreeData') + 9)); // 9 = length of 'qTreeData'
      shortenizer = SHORTEN_TD;
    }
    let shortenPath = true;
    if (DIM_RX.test(id)) {
      dimensionIdx = +DIM_RX.exec(id)[1];
    }
    if (M_RX.test(id)) {
      measureIdx = +M_RX.exec(id)[1];
    }
    if (ATTR_DIM_RX.test(id)) {
      measureIdx = -1;
      dimensionIdx = 0;
      const attrCol = +ATTR_DIM_RX.exec(path)[2];
      if (!isNaN(attrCol)) {
        dimensionIdx = attrCol;
        path = path.replace(/\/\d+$/, '');
      }
      shortenPath = false;
    }
    if (ATTR_EXPR_RX.test(id)) {
      // depends on number of measures + number of attr expressions
      // in dimensions and measures before this one
      const offset = measureIdx;
      if (layout) {
        measureIdx = 0;
        const hc = resolve(pathToCube, layout);

        // offset by number of measures
        measureIdx += (hc.qMeasureInfo || []).length;

        // offset by total number of attr expr in dimensions
        // (assuming attr expr in dimensions are ordered first)
        if (dimensionIdx > -1) {
          measureIdx = hc.qDimensionInfo.slice(0, dimensionIdx).reduce((v, dim) => v + dim.qAttrExprInfo.length, measureIdx);
          dimensionIdx = -1;
        } else {
          measureIdx = hc.qDimensionInfo.reduce((v, dim) => v + dim.qAttrExprInfo.length, measureIdx);
          // offset by total number of attr expr in measures before 'index'
          measureIdx = hc.qMeasureInfo.slice(0, offset).reduce((v, meas) => v + meas.qAttrExprInfo.length, measureIdx);
        }

        // offset by the actual column value for the attribute expression itself
        measureIdx += +ATTR_EXPR_RX.exec(path)[1];
      } else if (dimensionIdx > -1) {
        dimensionIdx = -1;
        measureIdx = +ATTR_EXPR_RX.exec(path)[1];
      } else {
        measureIdx += +ATTR_EXPR_RX.exec(path)[1] + 1;
      }
    }
    LAYOUT_TO_PROP.forEach(_ref => {
      let [v, prop] = _ref;
      path = path.replace(v, prop);
    });
    if (shortenPath) {
      path = shortenizer(path);
    }
    if (path && path[0] !== '/') {
      path = "/".concat(path);
    }
    return {
      measureIdx,
      dimensionIdx,
      path
    };
  }

  /**
   * Helper method to generate suitable QIX selection methods and parameters based on a brush instance.
   * @alias brush
   * @memberof picasso.q
   * @param {Brush} brush A brush instance
   * @param {object} [opts]
   * @param {boolean} [opts.byCells=false] Whether to prefer selection by row index.
   * @param {string} [opts.primarySource] Field source to extract row indices from. If not specified, indices from first source are used.
   * @param {boolean} [opts.orMode=true] If false, combine measure range selections.
   * @param {object} [layout] QIX data layout. Needed only when brushing on attribute expressions, to be able to calculate the measure index.
   * @return {object[]} An array of relevant selections
   */
  function qBrush(brush) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let layout = arguments.length > 2 ? arguments[2] : undefined;
    const byCells = opts.byCells;
    const primarySource = opts.primarySource;
    const selections = [];
    const methods = {};
    const isActive = brush.isActive();
    let hasValues = false;
    brush.brushes().forEach(b => {
      const info = extractFieldFromId(b.id, layout);
      if (b.type === 'range' && info.measureIdx > -1 && info.dimensionIdx > -1) {
        const ranges = b.brush.ranges();
        if (ranges.length) {
          hasValues = true;
          if (!methods.multiRangeSelectTreeDataValues) {
            methods.multiRangeSelectTreeDataValues = {
              path: info.path,
              ranges: []
            };
          }
          ranges.forEach(range => methods.multiRangeSelectTreeDataValues.ranges.push({
            qMeasureIx: info.measureIdx,
            qDimensionIx: info.dimensionIdx,
            qRange: {
              qMin: range.min,
              qMax: range.max,
              qMinInclEq: true,
              qMaxInclEq: true
            }
          }));
        }
      } else {
        if (b.type === 'range' && info.measureIdx > -1) {
          const ranges = b.brush.ranges();
          if (ranges.length) {
            hasValues = true;
            if (!methods.rangeSelectHyperCubeValues) {
              methods.rangeSelectHyperCubeValues = {
                path: info.path,
                ranges: []
              };
            }
            ranges.forEach(range => methods.rangeSelectHyperCubeValues.ranges.push({
              qMeasureIx: info.measureIdx,
              qRange: {
                qMin: range.min,
                qMax: range.max,
                qMinInclEq: true,
                qMaxInclEq: true
              }
            }));
          }
        }
        if (b.type === 'range' && info.dimensionIdx > -1) {
          const ranges = b.brush.ranges();
          if (ranges.length) {
            hasValues = true;
            if (!methods.selectHyperCubeContinuousRange) {
              methods.selectHyperCubeContinuousRange = {
                path: info.path,
                ranges: []
              };
            }
            ranges.forEach(range => methods.selectHyperCubeContinuousRange.ranges.push({
              qDimIx: info.dimensionIdx,
              qRange: {
                qMin: range.min,
                qMax: range.max,
                qMinInclEq: true,
                qMaxInclEq: false
              }
            }));
          }
        }
        if (b.type === 'value' && info.dimensionIdx > -1) {
          if (byCells) {
            if (layout && layout.qHyperCube && (layout.qHyperCube.qMode === 'P' || layout.qHyperCube.qMode === 'T' || layout.qHyperCube.qMode === 'K')) {
              const hyperCube = layout.qHyperCube;
              const noOfLeftDims = hyperCube.qNoOfLeftDims;
              const dimInterColSortIdx = hyperCube.qEffectiveInterColumnSortOrder.indexOf(info.dimensionIdx);
              if (!methods.selectPivotCells) {
                methods.selectPivotCells = {
                  path: info.path,
                  cells: []
                };
              }
              if (b.id === primarySource || !primarySource) {
                const validValues = b.brush.values().map(s => +s).filter(v => !isNaN(v));
                if ((noOfLeftDims === 0 || dimInterColSortIdx >= noOfLeftDims) && noOfLeftDims > -1) {
                  validValues.forEach(val => {
                    methods.selectPivotCells.cells.push({
                      qType: 'T',
                      qCol: val,
                      qRow: dimInterColSortIdx - noOfLeftDims
                    });
                  });
                } else {
                  validValues.forEach(val => {
                    methods.selectPivotCells.cells.push({
                      qType: 'L',
                      qCol: info.dimensionIdx,
                      qRow: val
                    });
                  });
                }
                hasValues = !!methods.selectPivotCells.cells.length;
              }
            } else {
              if (!methods.selectHyperCubeCells) {
                methods.selectHyperCubeCells = {
                  path: info.path,
                  cols: []
                };
              }
              methods.selectHyperCubeCells.cols.push(info.dimensionIdx);
              if (b.id === primarySource || !primarySource && !methods.selectHyperCubeCells.values) {
                methods.selectHyperCubeCells.values = b.brush.values().map(s => +s).filter(v => !isNaN(v));
                hasValues = !!methods.selectHyperCubeCells.values.length;
              }
            }
          } else {
            const values = b.brush.values().map(s => +s).filter(v => !isNaN(v));
            hasValues = !!values.length;
            selections.push({
              params: [info.path, info.dimensionIdx, values, false],
              method: 'selectHyperCubeValues'
            });
          }
        }
      }
    });
    if (!hasValues && isActive) {
      return [{
        method: 'resetMadeSelections',
        params: []
      }];
    }
    if (methods.rangeSelectHyperCubeValues) {
      var _opts$orMode;
      selections.push({
        method: 'rangeSelectHyperCubeValues',
        params: [methods.rangeSelectHyperCubeValues.path, methods.rangeSelectHyperCubeValues.ranges, [], (_opts$orMode = opts.orMode) !== null && _opts$orMode !== void 0 ? _opts$orMode : true]
      });
    }
    if (methods.selectHyperCubeContinuousRange) {
      selections.push({
        method: 'selectHyperCubeContinuousRange',
        params: [methods.selectHyperCubeContinuousRange.path, methods.selectHyperCubeContinuousRange.ranges]
      });
    }
    if (methods.selectHyperCubeCells) {
      selections.push({
        method: 'selectHyperCubeCells',
        params: [methods.selectHyperCubeCells.path, methods.selectHyperCubeCells.values, methods.selectHyperCubeCells.cols]
      });
    }
    if (methods.selectPivotCells) {
      selections.push({
        method: 'selectPivotCells',
        params: [methods.selectPivotCells.path, methods.selectPivotCells.cells]
      });
    }
    if (methods.multiRangeSelectTreeDataValues) {
      selections.push({
        method: 'multiRangeSelectTreeDataValues',
        params: [methods.multiRangeSelectTreeDataValues.path, methods.multiRangeSelectTreeDataValues.ranges]
      });
    }
    return selections;
  }

  function initialize(picasso) {
    q.util = picasso.data('matrix').util;
    picasso.data('q', q);
    picasso.formatter('q-number', formatter$1);
    picasso.formatter('q-time', formatter);
  }
  initialize.qBrushHelper = qBrush; // deprecated
  initialize.selections = qBrush;

  return initialize;

}));
//# sourceMappingURL=picasso-q.js.map
